import React, { useState, useContext } from "react";
import { useLocation, useHistory } from 'react-router-dom';
import SignUpForm from "./SignUpForm";
import { register, getVerify } from '../../api';
import { UserContext } from '../../context/User';
import { Container, Row, Col } from 'react-bootstrap';
import classes from './index.module.scss';
import { somethingWentWrongNotice, successNotice, emailPhoneExistingsNotice } from '../UI/Notifications';
 
const UserRegistration = () => {
  const [loading, setLoading] = useState(false);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const querystring = require('querystring');
  const role = query.get('role');
  
  const login = (userData) => {
    setIsLoggedIn(true);
    setUser(userData);
    history.push("/dashboard");
  }

  const verification = (responseData) => {
    const params = {
      user_id: responseData.user_id,
      hash_data: responseData.hash_data,
      link: `${window.origin}/user-verification`
    }

    getVerify(params)
      .then(() => {
        const queryString = querystring.stringify(params);
        setLoading(false);
        history.push(`/send-again?${queryString}`);
      })
      .catch(() => {
        somethingWentWrongNotice("Registration");
        setLoading(false);
      });
  }

  const registrationPost = (newObj) => {
    register(newObj)
      .then(response => {
        setLoading(false);
        login(response.data);
        successNotice("Registration");
      })
      .catch(error => {
        if (error.response.status === 409) {
          emailPhoneExistingsNotice();
          setLoading(false);
        }
        if (error.response.status === 401) {
          verification(error.response.data);
        }
        if (![401, 409].includes(error.response.status)) {
          somethingWentWrongNotice("Registration");
          setLoading(false);
        }
      });
  }

  const onSubmit = (data, e) => {
    e.preventDefault();
    e.target.reset();
    setLoading(true);

    const newObj = {
      ...data,
      userRole: role
    };

    registrationPost(newObj);
  }

  return (
    <section className={classes.User_Registration}>
      <Container>
        <Row>
          <Col lg={{ span: 10, offset: 1 }}>
            <div className="step-header">
              <h2>Registration</h2>
              <div className="step-container">
                <p>
                  Step <span>1</span> of {role === "business" ? "6" : "2"}
                </p>
              </div>
            </div>
            <p className="mb-5">
              Create your business user profile by completing the form below. Please use a valid email address.<br />
              You will receive a confirmation of your new account at the provided address. A * indicates a mandatory field.
            </p>
            <SignUpForm
              onSubmit={onSubmit}
              loading={loading}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default UserRegistration;